<template>
  <div id="myproject">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a>My Projects</a>
        </li>
      </ol>
    </div>

    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row mt20">
            <p class="sub-title text-center">MY PROJECTS</p>
            <div class="col-xs-12">
              <div class="row">
                <div class="col-xs-12 text-center">
                  <el-input
                    v-model="artwork_query"
                    size="big"
                    suffix-icon="el-icon-search"
                    placeholder="FIND A PROJECT"
                    class="mt20"
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="col-xs-12 mt30 mb10">
              <a href="#" @click="$refs.projectForm.showModal()">
                <span class="iconfont2 icon-g7 button-icon font36 mr20"></span>
                <span class="font18 black text-middle">ADD A PROJECT</span>
              </a>
            </div>
            <div class="col-xs-12 mb20">
              <div
                class="panel-group"
                style="margin-bottom: 50px"
                id="accordion"
              >
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingOne">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_redidential == undefined ||
                        filtered_redidential.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <span
                        class="iconfont3 icon-IconBig-ResidentialProjects3 button-icon mr20"
                      ></span>
                      RESIDENTIAL
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseOne"
                    class="panel-collapse collapse"
                    :class="
                      filtered_redidential == undefined ||
                      filtered_redidential.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w20"></th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.residential == 'customer_name',
                                desc: reverseSort.residential,
                                sort: true,
                              }"
                              @click="sort_by('residential', 'customer_name')"
                              >Customer Name</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.residential == 'country',
                                desc: reverseSort.residential,
                                sort: true,
                              }"
                              @click="sort_by('residential', 'country')"
                              >Country</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.residential == 'city',
                                desc: reverseSort.residential,
                                sort: true,
                              }"
                              @click="sort_by('residential', 'city')"
                              >City</a
                            >
                          </th>
                          <th class="text-right w10">
                            <a
                              :class="{
                                active: sortKey.residential == 'modified_at',
                                desc: reverseSort.residential,
                                sort: true,
                              }"
                              @click="sort_by('residential', 'modified_at')"
                              >Latest change</a
                            >
                          </th>
                          <th class="text-right w10">
                            <a class="sort">SO #</a>
                          </th>
                          <th class="text-right">
                            <a class="sort">AO</a>
                          </th>
                          <th class="text-right w10">
                            <a class="sort">ETA</a>
                          </th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in displayedResidential"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/project/' + i._id"
                                class="black mr20"
                                >Open</router-link
                              >

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                                v-if="canEdit(i.erp_document_no)"
                              >
                                <a
                                  class="black mr20"
                                  @click="editProject(i._id, 0)"
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Duplicate"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  @click="copy_project(i._id, 0)"
                                >
                                  <span
                                    class="iconfont3 icon-copy font18"
                                  ></span>
                                </a>
                              </el-tooltip>

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_project(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                            <td class>{{ i.customer_name }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.modified_at)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td>{{ i.erp_document_no }}</td>
                            <td class="text-right">
                              {{ checkERPao(i.erp_ao) }}
                            </td>
                            <td class="text-right">
                              {{ checkETA(i.erp_est_ship_date) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <nav
                        class="text-center"
                        v-if="pages.residential.length > 0"
                      >
                        <ul class="pagination">
                          <li
                            v-if="page.residential != 1"
                            @click="page.residential--"
                          >
                            <a aria-label="Previous">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-back font11"
                              ></span>
                            </a>
                          </li>
                          <li
                            v-for="(pageNumber, index) in pages.residential"
                            @click="page.residential = pageNumber"
                            :key="index"
                          >
                            <a
                              :class="{
                                active: pageNumber == page.residential,
                              }"
                              >{{ pageNumber }}</a
                            >
                          </li>
                          <li
                            @click="page.residential++"
                            v-if="page.residential < pages.residential.length"
                          >
                            <a aria-label="Next">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-next font11"
                              ></span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwo">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_hopspitality == undefined ||
                        filtered_hopspitality.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseTwo"
                    >
                      <span
                        class="iconfont3 icon-IconBig-ResidentialProjects button-icon mr20"
                      ></span>
                      HOSPITALITY
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseTwo"
                    class="panel-collapse collapse"
                    :class="
                      filtered_hopspitality == undefined ||
                      filtered_hopspitality.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w20"></th>
                          <th class="w15">
                            <a
                              :class="{
                                active: sortKey.hospitality == 'customer_name',
                                desc: reverseSort.hospitality,
                                sort: true,
                              }"
                              @click="sort_by('hospitality', 'customer_name')"
                              >Customer Name</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.hospitality == 'country',
                                desc: reverseSort.hospitality,
                                sort: true,
                              }"
                              @click="sort_by('hospitality', 'country')"
                              >Country</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.hospitality == 'city',
                                desc: reverseSort.hospitality,
                                sort: true,
                              }"
                              @click="sort_by('hospitality', 'city')"
                              >City</a
                            >
                          </th>
                          <th class="text-right w15">
                            <a
                              :class="{
                                active: sortKey.hospitality == 'modified_at',
                                desc: reverseSort.hospitality,
                                sort: true,
                              }"
                              @click="sort_by('hospitality', 'modified_at')"
                              >Latest change</a
                            >
                          </th>
                          <th class="text-right w10">
                            <a class="sort">SO #</a>
                          </th>
                          <th class="text-right w10">
                            <a class="sort">AO</a>
                          </th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in displayedHospitality"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/project/' + i._id"
                                class="black mr20"
                                >Open</router-link
                              >
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                                v-if="canEdit(i.erp_document_no)"
                              >
                                <a
                                  class="black mr20"
                                  @click="editProject(i._id, 1)"
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Duplicate"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  @click="copy_project(i._id, 1)"
                                >
                                  <span
                                    class="iconfont3 icon-copy font18"
                                  ></span>
                                </a>
                              </el-tooltip>

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_project(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                            <td class>{{ i.customer_name }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.modified_at)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td>{{ i.erp_document_no }}</td>
                            <td class="text-right">
                              {{ checkERPao(i.erp_ao) }}
                            </td>
                            <td class="text-right">
                              {{ checkETA(i.erp_est_ship_date) }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                      <nav
                        class="text-center"
                        v-if="pages.hospitality.length > 0"
                      >
                        <ul class="pagination">
                          <li
                            v-if="page.hospitality != 1"
                            @click="page.hospitality--"
                          >
                            <a aria-label="Previous">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-back font11"
                              ></span>
                            </a>
                          </li>
                          <li
                            v-for="(pageNumber, index) in pages.hospitality"
                            @click="page.hospitality = pageNumber"
                            :key="index"
                          >
                            <a
                              :class="{
                                active: pageNumber == page.hospitality,
                              }"
                              >{{ pageNumber }}</a
                            >
                          </li>
                          <li
                            @click="page.hospitality++"
                            v-if="page.hospitality < pages.hospitality.length"
                          >
                            <a aria-label="Next">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-next font11"
                              ></span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingThree">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_marine == undefined ||
                        filtered_marine.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseThree"
                    >
                      <span
                        class="iconfont3 icon-IconBig-ResidentialProjects1 button-icon mr20"
                      ></span>
                      MARINE
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseThree"
                    class="panel-collapse collapse"
                    :class="
                      filtered_marine == undefined ||
                      filtered_marine.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w20"></th>
                          <th class="w15">
                            <a
                              :class="{
                                active: sortKey.marine == 'customer_name',
                                desc: reverseSort.marine,
                                sort: true,
                              }"
                              @click="sort_by('marine', 'customer_name')"
                              >Customer Name</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.marine == 'country',
                                desc: reverseSort.marine,
                                sort: true,
                              }"
                              @click="sort_by('marine', 'country')"
                              >Country</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.marine == 'city',
                                desc: reverseSort.marine,
                                sort: true,
                              }"
                              @click="sort_by('marine', 'city')"
                              >City</a
                            >
                          </th>
                          <th class="text-right w15">
                            <a
                              :class="{
                                active: sortKey.marine == 'modified_at',
                                desc: reverseSort.marine,
                                sort: true,
                              }"
                              @click="sort_by('marine', 'modified_at')"
                              >Latest change</a
                            >
                          </th>
                          <th class="text-right w10">
                            <a class="sort">SO #</a>
                          </th>
                          <th class="text-right w10">
                            <a class="sort">AO</a>
                          </th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in displayedMarine"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/project/' + i._id"
                                class="black mr20"
                                >Open</router-link
                              >

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                                v-if="canEdit(i.erp_document_no)"
                              >
                                <a
                                  class="black mr20"
                                  @click="editProject(i._id, 2)"
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Duplicate"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  @click="copy_project(i._id, 2)"
                                >
                                  <span
                                    class="iconfont3 icon-copy font18"
                                  ></span>
                                </a>
                              </el-tooltip>

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_project(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                            <td class>{{ i.customer_name }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.modified_at)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td>{{ i.erp_document_no }}</td>
                            <td class="text-right">
                              {{ checkERPao(i.erp_ao) }}
                            </td>
                            <td class="text-right">
                              {{ checkETA(i.erp_est_ship_date) }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                      <nav class="text-center" v-if="pages.marine.length > 0">
                        <ul class="pagination">
                          <li v-if="page.marine != 1" @click="page.marine--">
                            <a aria-label="Previous">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-back font11"
                              ></span>
                            </a>
                          </li>
                          <li
                            v-for="(pageNumber, index) in pages.marine"
                            @click="page.marine = pageNumber"
                            :key="index"
                          >
                            <a :class="{ active: pageNumber == page.marine }">{{
                              pageNumber
                            }}</a>
                          </li>
                          <li
                            @click="page.marine++"
                            v-if="page.marine < pages.marine.length"
                          >
                            <a aria-label="Next">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-next font11"
                              ></span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingFour">
                    <h4
                      class="panel-title"
                      :class="
                        filtered_commercial == undefined ||
                        filtered_commercial.length <= 0
                          ? 'collapsed'
                          : ''
                      "
                      role="button"
                      data-toggle="collapse"
                      href="#collapseFour"
                    >
                      <span
                        class="iconfont3 icon-IconBig-ResidentialProjects3 button-icon mr20"
                      ></span>
                      COMMERCIAL
                      <span
                        class="glyphicon glyphicon-menu-up pull-right"
                        aria-hidden="true"
                      ></span>
                    </h4>
                  </div>
                  <div
                    id="collapseFour"
                    class="panel-collapse collapse"
                    :class="
                      filtered_commercial == undefined ||
                      filtered_commercial.length <= 0
                        ? ''
                        : 'in'
                    "
                    role="tabpanel"
                  >
                    <div class="panel-body">
                      <table class="table mb0 table-hover">
                        <tr>
                          <th class="w15">Name</th>
                          <th class="text-center w20"></th>
                          <th class="w15">
                            <a
                              :class="{
                                active: sortKey.commercial == 'customer_name',
                                desc: reverseSort.commercial,
                                sort: true,
                              }"
                              @click="sort_by('commercial', 'customer_name')"
                              >Customer Name</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.commercial == 'country',
                                desc: reverseSort.commercial,
                                sort: true,
                              }"
                              @click="sort_by('commercial', 'country')"
                              >Country</a
                            >
                          </th>
                          <th class="w10">
                            <a
                              :class="{
                                active: sortKey.commercial == 'city',
                                desc: reverseSort.commercial,
                                sort: true,
                              }"
                              @click="sort_by('commercial', 'city')"
                              >City</a
                            >
                          </th>
                          <th class="text-right w15">
                            <a
                              :class="{
                                active: sortKey.commercial == 'modified_at',
                                desc: reverseSort.commercial,
                                sort: true,
                              }"
                              @click="sort_by('commercial', 'modified_at')"
                              >Latest change</a
                            >
                          </th>
                          <th class="text-right w10">
                            <a class="sort">SO #</a>
                          </th>
                          <th class="text-right w10">
                            <a class="sort">AO</a>
                          </th>
                        </tr>
                        <!-- loop start -->
                        <tbody>
                          <tr
                            v-for="(i, index) in displayedCommercial"
                            :key="index"
                          >
                            <td class>{{ i.name }}</td>
                            <td class="text-center option h40">
                              <router-link
                                :to="'/project/' + i._id"
                                class="black mr20"
                                >Open</router-link
                              >

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Edit"
                                placement="top"
                                v-if="canEdit(i.erp_document_no)"
                              >
                                <a
                                  class="black mr20"
                                  @click="editProject(i._id, 3)"
                                >
                                  <span
                                    class="iconfont3 icon-edit font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Duplicate"
                                placement="top"
                              >
                                <a
                                  class="black mr20"
                                  @click="copy_project(i._id, 3)"
                                >
                                  <span
                                    class="iconfont3 icon-copy font18"
                                  ></span>
                                </a>
                              </el-tooltip>

                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="Delete"
                                placement="top"
                              >
                                <a
                                  class="black"
                                  @click="delete_project(i._id, i.name)"
                                >
                                  <span
                                    class="iconfont3 icon-delete font18"
                                  ></span>
                                </a>
                              </el-tooltip>
                            </td>
                            <td class>{{ i.customer_name }}</td>
                            <td class>{{ i.country }}</td>
                            <td class>{{ i.city }}</td>
                            <td class="text-right">
                              {{
                                new Date(i.modified_at)
                                  | dateFormat("DD.MM.YYYY")
                              }}
                            </td>
                            <td>{{ i.erp_document_no }}</td>
                            <td class="text-right">
                              {{ checkERPao(i.erp_ao) }}
                            </td>
                            <td class="text-right">
                              {{ checkETA(i.erp_est_ship_date) }}
                            </td>
                          </tr>
                        </tbody>

                        <!-- loop end -->
                      </table>
                      <nav
                        class="text-center"
                        v-if="pages.commercial.length > 0"
                      >
                        <ul class="pagination">
                          <li
                            v-if="page.commercial != 1"
                            @click="page.commercial--"
                          >
                            <a aria-label="Previous">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-back font11"
                              ></span>
                            </a>
                          </li>
                          <li
                            v-for="(pageNumber, index) in pages.commercial"
                            @click="page.commercial = pageNumber"
                            :key="index"
                          >
                            <a
                              :class="{ active: pageNumber == page.commercial }"
                              >{{ pageNumber }}</a
                            >
                          </li>
                          <li
                            @click="page.commercial++"
                            v-if="page.commercial < pages.commercial.length"
                          >
                            <a aria-label="Next">
                              <span
                                aria-hidden="true"
                                class="iconfont3 icon-next font11"
                              ></span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <project-form
      @project-updated="getData"
      ref="projectForm"
    />

    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="back()"
        ><i class="iconfont3 icon-back"></i> BACK</span
      >
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";
import ProjectForm from "../components/ProjectForm.vue";

export default {
  name: "myproject",
  components: {
    ProjectForm,
  },
  data() {
    return {
      projectList: [[], [], [], []],
      editable_project: {},
      artwork_query: "",
      timeout: null,
      loading: false,
      sortKey: {
        residential: "modified_at",
        hospitality: "modified_at",
        marine: "modified_at",
        commercial: "modified_at",
      },
      reverseSort: {
        residential: true,
        hospitality: true,
        marine: true,
        commercial: true,
      },
      page: {
        residential: 1,
        hospitality: 1,
        marine: 1,
        commercial: 1,
      },
      pages: {
        residential: [],
        hospitality: [],
        marine: [],
        commercial: [],
      },
      perPage: 5,
    };
  },
  watch: {
    filtered_redidential(newItems) {
      this.set_pages("residential", newItems);
    },
    filtered_hopspitality(newItems) {
      this.set_pages("hospitality", newItems);
    },
    filtered_marine(newItems) {
      this.set_pages("marine", newItems);
    },
    filtered_commercial(newItems) {
      this.set_pages("commercial", newItems);
    },
  },
  methods: {
    checkERPao(ao) {
      if (typeof ao != "undefined") {
        return ao.length > 0 ? "Yes" : "No";
      }
      return "No";
    },
    checkETA(date) {
      if (typeof date != "undefined") {
        return this.$options.filters.dateFormat(new Date(date), "DD.MM.YYYY");
      }
      return "N/A";
    },
    canEdit(erp_document_no) {
      if (
        typeof erp_document_no != "undefined" &&
        erp_document_no != null &&
        erp_document_no != ""
      ) {
        if (this.$store.state.user.type == "admin") {
          return true;
        }
        return false;
      }
      return true;
    },
    sort_by(type, sortKey) {
      this.reverseSort[type] =
        this.sortKey[type] == sortKey ? !this.reverseSort[type] : false;
      this.sortKey[type] = sortKey;
    },
    set_pages(type, items) {
      this.page[type] = 1;
      this.pages[type] = [];
      let numberOfPages = Math.ceil(items.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages[type].push(index);
      }
    },
    paginate(type, items) {
      let page = this.page[type];
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return items.slice(from, to);
    },
    back() {
      this.$router.push({ path: "/dashboard" });
    },
    getData: async function () {
      this.loading = true;
      axios
        .get("/project/" + this.$store.state.user._id)
        .then((response) => {
          var Residential = [];
          var Hospitality = [];
          var Marine = [];
          var Commercial = [];

          response.data.forEach(function (item) {
            if (item.category == 1) Residential.push(item);
            else if (item.category == 2) Hospitality.push(item);
            else if (item.category == 3) Marine.push(item);
            else if (item.category == 4) Commercial.push(item);
          });
          this.projectList = [Residential, Hospitality, Marine, Commercial];
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
          alert(error);
        });
    },
    editProject(id, sort) {
      this.$refs.projectForm.showModal(Object.assign(
        {},
        this.projectList[sort].find((i) => i._id == id)
      ));
    },
    async getRoomList(pid) {
      return await axios.get("/roomtype/" + pid);
    },
    changePIdsOnRooms(rooms, pid) {
      return rooms.map((room) => {
        room.pid = pid;
        return room;
      });
    },
    async copy_project(id, sort) {
      this.loading = true;
      var project = Object.assign(
        {},
        this.projectList[sort].find((i) => i._id == id)
      );
      var rooms = await this.getRoomList(project._id);
      delete project._id;
      delete project.erp_document_no;
      delete project.erp_ao
      
      axios
        .post("/project/", {
          project: project,
        })
        .then(async (res) => {
          if (res.data.ok == 1) {
            rooms = this.changePIdsOnRooms(rooms.data, res.data.insertedId);
            for (var room of rooms) {
              await axios.post("/roomtype/duplicate", { roomtype: room });
            }
            this.$message({
              type: "success",
              message: "Copied!",
            });
            this.loading = false;
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: "Copy Failed!",
            });
            this.loading = false;
          }
        })
        .catch(function (error) {
          alert(error);
          this.loading = false;
        });
    },
    delete_project(ID, name) {
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE PROJECT",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/project/" + ID)
              .then((res) => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!",
                  });
                  this.getData();
                  done();
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch(function (error) {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
    sortArrayOfObjects(arr, column, reverse) {
      arr.sort((a, b) => {
        var textA, textB;
        if (column == "modified_at") {
          textA = new Date(a[column]);
          textB = new Date(b[column]);
        } else {
          textA = a[column].toUpperCase();
          textB = b[column].toUpperCase();
        }
        if (!reverse) {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA < textB ? 1 : textA > textB ? -1 : 0;
        }
      });
      return arr;
    },
  },
  async mounted() {
    this.$parent.footerB();
    await this.getData();
  },
  computed: {
    filtered_redidential: function () {
      var a = this.projectList[0].filter((project) => {
        return project.name
          .toLowerCase()
          .includes(this.artwork_query.toLowerCase());
      });
      return this.sortArrayOfObjects(
        a,
        this.sortKey.residential,
        this.reverseSort.residential
      );
    },
    filtered_hopspitality: function () {
      var a = this.projectList[1].filter((project) => {
        return project.name
          .toLowerCase()
          .includes(this.artwork_query.toLowerCase());
      });
      return this.sortArrayOfObjects(
        a,
        this.sortKey.hospitality,
        this.reverseSort.hospitality
      );
    },
    filtered_marine: function () {
      var a = this.projectList[2].filter((project) => {
        return project.name
          .toLowerCase()
          .includes(this.artwork_query.toLowerCase());
      });
      return this.sortArrayOfObjects(
        a,
        this.sortKey.marine,
        this.reverseSort.marine
      );
    },
    filtered_commercial: function () {
      var a = this.projectList[3].filter((project) => {
        return project.name
          .toLowerCase()
          .includes(this.artwork_query.toLowerCase());
      });
      return this.sortArrayOfObjects(
        a,
        this.sortKey.commercial,
        this.reverseSort.commercial
      );
    },
    displayedResidential() {
      return this.paginate("residential", this.filtered_redidential);
    },
    displayedHospitality() {
      return this.paginate("hospitality", this.filtered_hopspitality);
    },
    displayedMarine() {
      return this.paginate("marine", this.filtered_marine);
    },
    displayedCommercial() {
      return this.paginate("commercial", this.filtered_commercial);
    },
  },
};
</script>

<style></style>
